import React, { useCallback, useEffect, useState } from 'react'
import { CircularProgress, Tabs, Tab } from '@material-ui/core'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

// Hooks, Components e Estilos do Sistema 🛰️🧼💎
import { Page, Header, CustomTable } from 'components'
import { useExameSolicitadoService } from 'hooks/useExameSolicitadoService'
import useRouter from 'utils/useRouter'
import { useStyles } from './MeusExamesSolicitados.styles'

export const MeusExamesSolicitados = (props) => {
  const { route } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const router = useRouter()
  const exameSolicitadoService = useExameSolicitadoService()

  const [tabValue, setTabValue] = useState(0)
  const [meusExamesEmAndamento, setMeusExamesEmAndamento] = useState([])
  const [meusExamesFinalizados, setMeusExamesFinalizados] = useState([])
  const [processandoEmAndamento, setProcessandoEmAndamento] = useState(true)
  const [processandoFinalizados, setProcessandoFinalizados] = useState(true)

  const fetchExamesEmAndamento = useCallback(async () => {
    try {
      const response = await exameSolicitadoService.listarExamesDoUsuarioEmAndamentoAsync(setProcessandoEmAndamento)
      setMeusExamesEmAndamento(response || [])
    } catch (error) {
      console.error('Erro ao buscar exames em andamento:', error)
      setProcessandoEmAndamento(false)
    }
  }, [])

  const fetchExamesFinalizados = useCallback(async () => {
    try {
      const response = await exameSolicitadoService.listarExamesDoUsuarioFinalizadosAsync(setProcessandoFinalizados)
      setMeusExamesFinalizados(response || [])
    } catch (error) {
      console.error('Erro ao buscar exames finalizados:', error)
      setProcessandoFinalizados(false)
    }
  }, [])

  useEffect(() => {
    fetchExamesEmAndamento()
    fetchExamesFinalizados()
  }, [fetchExamesEmAndamento, fetchExamesFinalizados])

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleRowClick = (idExame) => {
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${idExame}`)
  }

  const colunas = [
    {
      title: 'Identificador',
      field: 'exReal.numeroExame',
      cellStyle: { fontWeight: 600, width: '15%', minWidth: '120px' },
      render: (rowData) => rowData.exReal?.numeroExame || '-',
    },
    {
      title: 'Tipo',
      field: 'tipoEx.nome',
      render: (rowData) => rowData.tipoEx?.nome?.toUpperCase() || '-',
      cellStyle: { minWidth: '150px' },
    },
    {
      title: 'Setor responsável',
      field: 'setor.nome',
      render: (rowData) => rowData.setor?.nome?.toUpperCase() || '-',
      cellStyle: { minWidth: '180px' },
    },
    {
      title: 'Solicitado em',
      field: 'solEx.data',
      render: (rowData) => (rowData.solEx?.data ? moment(rowData.solEx.data).format('DD/MM/YYYY HH:mm') : '-'),
      cellStyle: { width: '15%', minWidth: '160px' },
    },
    {
      title: tabValue === 0 ? 'Atribuído em' : 'Iniciado em',
      field: 'exReal.dataInicio',
      render: (rowData) => (rowData.exReal?.dataInicio ? moment(rowData.exReal.dataInicio).format('DD/MM/YYYY HH:mm') : '-'),
      cellStyle: { width: '15%', minWidth: '160px' },
    },
    {
      title: 'Status',
      field: 'exReal.status',
      render: (rowData) => rowData.exReal?.status?.toUpperCase() || '-',
      cellStyle: { width: '12%', minWidth: '120px' },
    },
  ]

  const estaCarregando = tabValue === 0 ? processandoEmAndamento : processandoFinalizados
  const dadosTabela = tabValue === 0 ? meusExamesEmAndamento : meusExamesFinalizados

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.secao}`} overline={route.secao} />

      <div className={classes.tabsContainer}>
        <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" aria-label="Abas de Filtros de Exames Solicitados">
          <Tab label="Em Andamento" className={classes.tab} />
          <Tab label="Finalizados" className={classes.tab} />
        </Tabs>
      </div>

      {estaCarregando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <CustomTable columns={colunas} data={dadosTabela} onRowClick={(event, rowData) => handleRowClick(rowData.id)} searchPlaceholder="Buscar exames..." emptyDataSourceMessage="Nenhum exame solicitado encontrado" />
      )}
    </Page>
  )
}
